import React, { useState } from "react";
import { Button } from "@mui/material";
import { normalizeWeights, randomWeights } from "../helpers/teamProposal";

export default function TeamWeightSetup({ sources, names, en, onApply }) {
  const t = (de, eng) => (en ? eng : de);
  const [open, setOpen] = useState(false),
    [ratings, setRatings] = useState({}),
    [pace, setPace] = useState(2.5);
  const keys = sources
    .filter((s) => s.enabled || s.desiredSelectable)
    .map((s) => s.key);
  return (
    <section className="tw-weight-setup">
      <Button onClick={() => setOpen(!open)}>
        {t("Gewichtung angeleitet festlegen", "Choose weights with guidance")}
      </Button>
      <Button onClick={() => onApply(randomWeights(keys), null, "random")}>
        {t("🎲 Gewichte würfeln", "🎲 Roll random weights")}
      </Button>
      <small>
        {t(
          "Würfeln: je Quelle 5–25 Zufallspunkte, danach anteilig auf 100 % verteilt. Keine fachliche Empfehlung. Erneutes Würfeln ersetzt nur die Gewichtung.",
          "Dice: 5–25 random points per source, then normalized to 100%. Not an evidence-based recommendation. Rolling again only replaces the weights."
        )}
      </small>
      {open && (
        <div className="tw-weight-questions">
          <p>
            {t(
              "Wie wichtig sind dir diese Grundlagen? 0 = irrelevant, 10 = sehr wichtig. Saisonleistung und jüngste Leistung werden gegen die Erwartung derselben Spiele eingeordnet. Die Zahlen sind deine persönliche Einschätzung, keine Modellbewertung.",
              "How important are these sources to you? 0 = irrelevant, 10 = very important. Season and recent performance are compared with expectations for the same matches. These numbers express your preferences, not model quality."
            )}
          </p>
          {sources
            .filter((s) => keys.includes(s.key))
            .map((s) => (
              <label key={s.key}>
                {names[s.key]}
                <input
                  aria-label={`${t("Wichtigkeit", "Importance")} ${
                    names[s.key]
                  }`}
                  type="range"
                  min="0"
                  max="10"
                  step="1"
                  value={ratings[s.key] || 0}
                  onChange={(e) =>
                    setRatings({ ...ratings, [s.key]: Number(e.target.value) })
                  }
                />
                <output>{ratings[s.key] || 0} / 10</output>
              </label>
            ))}
          <label>
            {t("Konservativ → progressiv", "Conservative → progressive")}
            <input
              aria-label={t(
                "Konservativ bis progressiv",
                "Conservative to progressive"
              )}
              type="range"
              min="0"
              max="10"
              step="0.5"
              value={pace}
              onChange={(e) => setPace(Number(e.target.value))}
            />
            <output>
              {pace} / 10 → {pace * 10} %
            </output>
          </label>
          <small>
            {t(
              "Diese Skala legt ausschließlich die Anpassungsstärke fest: 0 = gespeicherten Wert halten, 10 = den gewichteten Zielwert vollständig erreichen. Sie verändert nicht das Vertrauen in einzelne Quellen.",
              "This scale only sets adjustment strength: 0 = keep the saved value, 10 = fully reach the weighted target. It does not change trust in individual sources."
            )}
          </small>
          <Button
            disabled={!keys.some((k) => ratings[k] > 0)}
            onClick={() => {
              onApply(normalizeWeights(ratings, keys), pace * 10, "guided");
              setOpen(false);
            }}
          >
            {t("Meine Einschätzung verwenden", "Use my preferences")}
          </Button>
        </div>
      )}
    </section>
  );
}
